import http from '../jslibs/axios/http';
import dLAxiosFile from '@/jslibs/axios/download-file';


//获取用户列表 
export const getUserList = data => http.get('/cms/User', data);

//新增用户 
export const addUser = data => http.post('/cms/User', data);

//编辑用户 
export const editUser = data => http.put('/cms/User/' + data.uuid, data);

//上下架用户 
export const UserDisable = data => http.put('/cms/UserDisable/' + data.id, data);

//用户重置密码 
export const UserPassword = data => http.put('/cms/UserPassword/' + data.id, data);

//删除用户 
export const deleteUser = data => http.delete('/cms/User/' + data.id, data);

//获取用户详情 
export const getUser = data => http.get('/cms/User/' + data.uuid);

//获取用户生图列表
export const getDoubao = data => http.get('/cms/Doubao', data);


export const getAiApplicationHistoryList = data => http.get('/cms/AiApplicationHistoryList', data);

//获取用户PPT创作记录列表
export const getPPTList = data => http.get('/cms/AIPPT', data);

//导出用户列表
export const downloadUserExcel = data => dLAxiosFile({
	url: '/cms/UserExport',
	method: 'GET',
	params: data
});